import osmtogeojson from "osmtogeojson";

class External {
    static fetchOverpassRoads(coords) {
        const preparedCoords = coords.map((item) => item.join(" ")).join(" ");

        const exclude = [
            "cycleway",
            "footway",
            "bridleway",
            "steps",
            "corridor",
            "pedestrian",
            "path",
            "track",
            "service"
        ];

        const query = `[out:json][timeout:10];(way["highway"]${exclude
            .map((item) => `["highway"!~"${item}"]`)
            .join("")}(poly:"${preparedCoords}"););out geom;`;

        // console.log(query);

        // https://lz4.overpass-api.de/api/interpreter
        // https://overpass-api.de/api/interpreter
        // https://overpass.kumi.systems/api/interpreter
        return fetch("https://overpass-api.de/api/interpreter", {
            body: query,
            headers: {
                Accept: "application/json"
            },
            method: "POST"
        })
            .then((response) => response.json())
            .catch((error) => {
                throw error;
            });
    }

    static async getRoads(coords) {
        const osmData = await External.fetchOverpassRoads(coords);

        return osmtogeojson(osmData, {
            flatProperties: true
        });
    }
}

export default External;
